export enum CustomAttributeType {
  CREATE_EDIT = 0,
  COVER_PHOTO = 1,
  TRIBUTE_VIDEO = 2
}
